module.exports = require('./dist/editor');